export default "__VITE_ASSET__Zz7o_7NeIMnYzYvY1rh_AA__ 480w, __VITE_ASSET__tMTfgZcGGlZOUyYIXeBUUQ__ 848w";